import { useUpdateAtom } from 'jotai/utils';
import { openFilterAtom } from 'global/store';
import { Box } from '@xstyled/styled-components';
import Button from '.';
import { Filter } from '@/UI/Icons/Catalogue';

export default function FilterButton() {
  const setFilterOpen = useUpdateAtom(openFilterAtom);

  return (
    <Box
      display={{ desktop: 'none' }}
      justifySelf={{ _: 'flex-start', mobile: 'flex-end' }}
      alignSelf={{ _: 'flex-start', mobile: 'center' }}
    >
      <Button onClick={() => setFilterOpen(true)}>
        <span className="filter" role="img" aria-label="Filter">
          {Filter}
        </span>
        &nbsp; Filtreeri
      </Button>
    </Box>
  );
}
